const axios = require("axios");

const instance = axios.create({
       baseURL: "http://197.248.111.170:2001",
      //  baseURL: "http://192.168.5.29:85",
  });

export default instance;
